import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { EyeIcon, EyeOffIcon } from 'lucide-react';
import { Button } from '../components/Button';
export function Login() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false
  });
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({
    email: '',
    password: ''
  });
  const handleChange = e => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };
  const validateForm = () => {
    const newErrors = {
      email: '',
      password: ''
    };
    let isValid = true;
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
      isValid = false;
    }
    if (!formData.password.trim()) {
      newErrors.password = 'Password is required';
      isValid = false;
    }
    setErrors(newErrors);
    return isValid;
  };
  const handleSubmit = e => {
    e.preventDefault();
    if (validateForm()) {
      // Submit the form data to backend (simulated)
      console.log('Login form submitted:', formData);
      // Redirect to dashboard
      window.location.href = '/dashboard';
    }
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  return <div className="w-full min-h-screen bg-[#1E2A38] text-[#F5F7FA] font-sans flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8" data-id="element-2499">
      <div className="max-w-md w-full bg-[#1A2331] rounded-xl shadow-lg overflow-hidden" data-id="element-2500">
        <div className="p-8" data-id="element-2501">
          <div className="flex justify-center mb-6" data-id="element-2502">
            <Link to="/" className="flex items-center" data-id="element-2503">
              <svg className="h-10 w-auto" viewBox="0 0 50 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-2504">
                <rect x="6" y="4" width="16" height="16" rx="2" fill="#C8F169" data-id="element-2505" />
                <path d="M10 8H14M10 12H18M10 16H16" stroke="#1E2A38" strokeWidth="2" strokeLinecap="round" data-id="element-2506" />
                <rect x="26" y="4" width="16" height="16" rx="2" fill="#C8F169" data-id="element-2507" />
                <circle cx="34" cy="12" r="5" stroke="#1E2A38" strokeWidth="2" data-id="element-2508" />
                <path d="M34 9V12L36 14" stroke="#1E2A38" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-2509" />
              </svg>
            </Link>
          </div>
          <h1 className="text-2xl font-bold text-center mb-2" data-id="element-2510">Welcome Back</h1>
          <p className="text-center text-[#F5F7FA] text-opacity-70 mb-8" data-id="element-2511">
            Log in to access your personalized meeting briefs and AI insights
          </p>
          <form onSubmit={handleSubmit} data-id="element-2512">
            <div className="mb-4" data-id="element-2513">
              <label htmlFor="email" className="block text-sm font-medium mb-1" data-id="element-2514">
                Email address
              </label>
              <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className={`w-full bg-[#1E2A38] border ${errors.email ? 'border-red-500' : 'border-[#F5F7FA] border-opacity-10'} rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#C8F169] focus:ring-opacity-50`} placeholder="you@example.com" data-id="element-2515" />
              {errors.email && <p className="mt-1 text-xs text-red-500" data-id="element-2516">{errors.email}</p>}
            </div>
            <div className="mb-4" data-id="element-2517">
              <div className="flex justify-between items-center mb-1" data-id="element-2518">
                <label htmlFor="password" className="block text-sm font-medium" data-id="element-2519">
                  Password
                </label>
                <a href="#forgot-password" className="text-sm text-[#C8F169] hover:underline" data-id="element-2520">
                  Forgot password?
                </a>
              </div>
              <div className="relative" data-id="element-2521">
                <input type={showPassword ? 'text' : 'password'} id="password" name="password" value={formData.password} onChange={handleChange} className={`w-full bg-[#1E2A38] border ${errors.password ? 'border-red-500' : 'border-[#F5F7FA] border-opacity-10'} rounded-lg px-4 py-2 pr-10 focus:outline-none focus:ring-2 focus:ring-[#C8F169] focus:ring-opacity-50`} placeholder="Enter your password" data-id="element-2522" />
                <button type="button" className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm" onClick={togglePasswordVisibility} data-id="element-2523">
                  {showPassword ? <EyeOffIcon className="h-5 w-5 text-[#F5F7FA] text-opacity-60" data-id="element-2524" /> : <EyeIcon className="h-5 w-5 text-[#F5F7FA] text-opacity-60" data-id="element-2525" />}
                </button>
              </div>
              {errors.password && <p className="mt-1 text-xs text-red-500" data-id="element-2526">{errors.password}</p>}
            </div>
            <div className="flex items-center mb-6" data-id="element-2527">
              <input type="checkbox" id="rememberMe" name="rememberMe" checked={formData.rememberMe} onChange={handleChange} className="h-4 w-4 rounded border-[#F5F7FA] border-opacity-30 text-[#C8F169] focus:ring-[#C8F169] focus:ring-opacity-50 bg-[#1E2A38]" data-id="element-2528" />
              <label htmlFor="rememberMe" className="ml-2 block text-sm text-[#F5F7FA] text-opacity-80" data-id="element-2529">
                Remember me
              </label>
            </div>
            <button type="submit" className="w-full bg-[#3B82F6] hover:bg-opacity-90 text-white font-medium py-2 px-4 rounded-lg transition-colors" data-id="element-2530">
              Log In
            </button>
            <div className="mt-6 text-center" data-id="element-2531">
              <div className="relative" data-id="element-2532">
                <div className="absolute inset-0 flex items-center" data-id="element-2533">
                  <div className="w-full border-t border-[#F5F7FA] border-opacity-10" data-id="element-2534"></div>
                </div>
                <div className="relative flex justify-center" data-id="element-2535">
                  <span className="px-2 bg-[#1A2331] text-sm text-[#F5F7FA] text-opacity-70" data-id="element-2536">
                    or with
                  </span>
                </div>
              </div>
            </div>
            <button type="button" className="mt-4 w-full flex items-center justify-center bg-[#1E2A38] border border-[#F5F7FA] border-opacity-10 text-[#F5F7FA] font-medium py-2 px-4 rounded-lg hover:bg-opacity-90 transition-colors" data-id="element-2537">
              <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-2538">
                <path d="M12.24 10.285V14.4h6.806c-.275 1.765-2.056 5.174-6.806 5.174-4.095 0-7.439-3.389-7.439-7.574s3.345-7.574 7.439-7.574c2.33 0 3.891.989 4.785 1.849l3.254-3.138C18.189 1.186 15.479 0 12.24 0c-6.635 0-12 5.365-12 12s5.365 12 12 12c6.926 0 11.52-4.869 11.52-11.726 0-.788-.085-1.39-.189-1.989H12.24z" fill="#4285F4" data-id="element-2539" />
              </svg>
              Login with Google
            </button>
            <p className="mt-6 text-center text-sm" data-id="element-2540">
              Don't have an account?{' '}
              <Link to="/signup" className="text-[#C8F169] hover:underline" data-id="element-2541">
                Sign Up
              </Link>
            </p>
          </form>
        </div>
      </div>
    </div>;
}